import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function GrievanceOfficer() {
  return (
    <div className="page-wrapper" style={{ paddingTop: '80px' }}>
      <SEOHead
        title="Grievance Officer — Redcubical Systems"
        description="Contact the Grievance Officer of Redcubical Systems for data privacy complaints, DPDP Act 2023 requests, and legal notices."
        canonical="/grievance-officer"
      />

      <section style={{
        padding: '80px 32px 120px',
        background: 'var(--black)',
        minHeight: '100vh',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

          {/* Header */}
          <div style={{ marginBottom: '56px' }}>
            <span className="section-label" style={{ marginBottom: '16px' }}>
              Legal · Compliance
            </span>
            <h1 style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontSize: 'clamp(36px, 6vw, 64px)',
              fontWeight: '900', color: '#fff',
              textTransform: 'uppercase',
              lineHeight: 1.05, marginBottom: '16px',
            }}>
              GRIEVANCE OFFICER
            </h1>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.35)',
            }}>
              In compliance with the Information Technology Act 2000,
              the IT (Intermediary Guidelines) Rules 2021,
              and the Digital Personal Data Protection Act 2023
            </p>
          </div>

          {/* Officer Card */}
          <div style={{
            padding: '40px',
            background: 'rgba(59,130,246,0.06)',
            border: '1px solid rgba(59,130,246,0.2)',
            borderRadius: '20px',
            marginBottom: '48px',
          }}>
            <p style={{
              fontSize: '11px', fontWeight: '700',
              color: '#3B82F6', letterSpacing: '2px',
              textTransform: 'uppercase', marginBottom: '24px',
            }}>
              Designated Grievance Officer
            </p>

            {[
              { label: 'Name', value: 'Ashish Uniyal' },
              { label: 'Designation', value: 'Founder & Grievance Officer' },
              { label: 'Company', value: 'Redcubical Systems Private Limited' },
              { label: 'Email', value: 'a.uniyal@redcubicalsystems.com' },
              { label: 'Phone', value: '+91 9368487416' },
              {
                label: 'Address',
                value: 'Dev Heights, First Floor, Aman Vihar, Sahastradhara Road, Dehradun — 248001, Uttarakhand, India',
              },
              { label: 'Response Time', value: 'Within 30 days of receipt' },
            ].map((item) => (
              <div key={item.label} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                padding: '14px 0',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
                gap: '24px',
              }}>
                <span style={{
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.35)',
                  flexShrink: 0, minWidth: '100px',
                }}>
                  {item.label}
                </span>
                <span style={{
                  fontSize: '14px',
                  color: 'rgba(255,255,255,0.75)',
                  fontWeight: '500',
                  textAlign: 'right',
                }}>
                  {item.value}
                </span>
              </div>
            ))}
          </div>

          {/* What to include */}
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '32px',
          }}>
            {[
              {
                title: 'How to File a Grievance',
                content: `To file a grievance, send an email to a.uniyal@redcubicalsystems.com with the subject line "Grievance — [Brief Description]".

Your grievance should include:

— Your full name and contact details
— A clear description of the nature of your grievance
— The specific product or service involved (HealHub, Suraksha, Vedant, or website)
— Any relevant dates, screenshots, or supporting documentation
— The resolution you are seeking

We will acknowledge receipt of your grievance within 48 hours and resolve it within 30 days.`,
              },
              {
                title: 'Types of Grievances We Handle',
                content: `Our Grievance Officer handles complaints relating to:

Data Privacy: Concerns about how we collect, use, store, or share your personal data.

DPDP Act 2023 Requests: Requests to access, correct, or delete your personal data.

Content Complaints: Objections to any content published on our platforms.

Service Complaints: Issues with any of our software products or services.

Security Incidents: Reports of suspected data breaches or security vulnerabilities.

Legal Notices: Service of legal notices or court orders.`,
              },
              {
                title: 'Escalation',
                content: `If your grievance is not resolved to your satisfaction within 30 days, you may escalate to:

The Data Protection Board of India (once constituted under the DPDP Act 2023)

Or seek remedies available under the Information Technology Act 2000 and applicable Indian law.`,
              },
              {
                title: 'DPDP Act 2023 — Your Rights',
                content: `Under the Digital Personal Data Protection Act 2023, you have the right to:

Right to Access: Know what personal data we hold about you and how it is being used.

Right to Correction: Have inaccurate personal data corrected.

Right to Erasure: Have your personal data deleted when it is no longer necessary.

Right to Grievance Redressal: File a complaint with our Grievance Officer and receive a response within 30 days.

Right to Nominate: Nominate another person to exercise your rights in the event of your death or incapacity.

To exercise any of these rights, contact the Grievance Officer using the details above.`,
              },
            ].map((section, i) => (
              <div key={i} style={{
                paddingBottom: '32px',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
              }}>
                <h2 style={{
                  fontFamily: 'Barlow Condensed, sans-serif',
                  fontSize: '22px', fontWeight: '900',
                  color: '#fff', textTransform: 'uppercase',
                  marginBottom: '16px',
                }}>
                  {section.title}
                </h2>
                <div style={{
                  fontSize: '15px',
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: '1.85',
                  whiteSpace: 'pre-line',
                }}>
                  {section.content}
                </div>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div style={{ marginTop: '64px', display: 'flex', gap: '16px' }}>
            <Link to="/" className="btn-outline"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              ← Back to Home
            </Link>
            <Link to="/contact" className="btn-blue"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              Contact Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}